import React from 'react';
import {DatePicker} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/ja_JP';

const RemindFilter = () => {
  const {query, setQuery} = useSearchParams();

  return (
    <>
      <DatePicker
        placeholder="開始日"
        value={query.remindFrom && moment(query.remindFrom)}
        locale={locale}
        onChange={(value) => {
          setQuery({page: 1, remindFrom: value?.format()});
        }}
        className="w-36"
      />
      <span className="mx-1 mt-2">~</span>
      <DatePicker
        placeholder="終了日"
        value={query.remindTo && moment(query.remindTo)}
        locale={locale}
        onChange={(value) => {
          setQuery({page: 1, remindTo: value?.format()});
        }}
        className="w-36"
      />
    </>
  );
};

export default RemindFilter;
